// GENLOYAL: WCAG-based replacement for @chatwoot/utils' getContrastingTextColor.
// Upstream decides with linear RGB weights and a 186/255 cutoff, which leaves
// mid-light widget colors (e.g. #F06292) with white text at ~3:1 contrast —
// unreadable in practice. This computes real WCAG relative luminance and picks
// black or white by which one actually contrasts better (white text wins only
// below L ≈ 0.1791, the equal-contrast point). Same signature and return
// values as upstream so call sites swap the import and nothing else.
const channelToLinear = value => {
  const c = value / 255;
  return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
};

export const getContrastingTextColor = bgColor => {
  const match = /^#?([0-9a-fA-F]{6})/.exec(String(bgColor || '').trim());
  if (!match) return '#FFFFFF';
  const n = parseInt(match[1], 16);
  const luminance =
    0.2126 * channelToLinear((n >> 16) & 255) +
    0.7152 * channelToLinear((n >> 8) & 255) +
    0.0722 * channelToLinear(n & 255);
  return luminance < 0.1791 ? '#FFFFFF' : '#000000';
};
